export enum ContractFilter {
  PerAssetContracts = 1,
  MultiAssetContracts = 2,
  All = 3
}

export enum ContractType {
  ServiceOnly = 1,
  FullMaintenanceContract = 2,
  FullMaintenanceLease = 3
}

export enum ContractColumnId {
  Assets = 1,
  ServiceCenterName = 2,
  ContractNumber = 3,
  FinancialProviderName = 4,
  StartDate = 6,
  EndDate = 7,
  ContractPeriod = 8,
  ContractType = 9,
  ContractualKmPerMonth = 10,
  FixedMonthlyCost = 11,
  Terms = 12,
  VariableCpk = 13
}